import { useState } from "react"

const BecomeInstructor = () => {
  const [loading, setLoading] = useState(false);
  let token = localStorage.getItem("token");
  token = token!.replace(/(^"|"$)/g, '');
  const id = token;
  
  const handleClick = async () => {
    console.log(id);
    
    const response = await fetch(`https://api-j06q.onrender.com/api/instructor/become-instructor/${id}`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id }),
      
    })
    const data = await response.json();
    
    window.location.href = data;
    
    
  }
      
  return (
    <div>
      <h1>Become Instructor</h1>

      <div>
        <div>
          <div>
            <h2>Setup Payment to publish Courses on WE LEARN!</h2>
            <p>WE LEARN partners with stripe to transfer earnings to your bank account.</p>
            <button onClick={handleClick}>Get Started!</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BecomeInstructor